"use client"

import { createContext, useContext, type ReactNode } from "react"
import { useParams } from "next/navigation"

/**
 * 병원 상세 화면들이 공유하는 "지금 보고 있는 병원".
 *
 * 예전에는 모든 조각이 라우트에서 직접 `useParams().id` 를 읽었다. 폐기된 pretty URL과
 * 숫자형 정본 URL이 함께 있던 시기에는 첫 세그먼트가 병원 ID가 아닌 지역 슬러그일 수 있었다.
 *
 * 그래서 ID 는 라우트 모양이 아니라 페이지가 알려 준다. 프로바이더가 없으면 예전처럼
 * `[id]` 로 폴백하므로 기존 페이지의 동작은 그대로다.
 */
const HospitalOriginIdContext = createContext<number | null>(null)

export const HospitalOriginIdProvider = ({
  hospitalOriginId,
  children,
}: {
  hospitalOriginId: number
  children: ReactNode
}) => (
  <HospitalOriginIdContext.Provider value={hospitalOriginId}>
    {children}
  </HospitalOriginIdContext.Provider>
)

export const useHospitalOriginId = (): number => {
  const provided = useContext(HospitalOriginIdContext)
  const params = useParams() as { id?: string | string[] } | null
  if (provided != null) return provided

  const routeId = Array.isArray(params?.id) ? params?.id[0] : params?.id
  return Number(routeId)
}
